/* =====================================================================
   COZY — motion morbido
   Header soffice allo scroll, reveal gentili, parallasse lieve del
   banner, alone caldo che segue il cursore, zoom galleria prodotto.
   Rispetta prefers-reduced-motion e l'opzione "Animazioni" (body.no-anim).
   ===================================================================== */
(function () {
  "use strict";
  var body = document.body;
  if (!body || !body.classList.contains("cozy")) return;

  var root = document.documentElement;
  var reduce =
    body.classList.contains("no-anim") ||
    (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  var fine =
    window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  /* ---------- Header + parallasse banner (un solo listener) ---------- */
  var header = document.querySelector(".site-header");
  var parallax = reduce ? [] : Array.prototype.slice.call(document.querySelectorAll(".image-banner__bg"));
  var queued = false;

  function onFrame() {
    queued = false;
    if (header) header.classList.toggle("is-scrolled", window.scrollY > 24);
    if (!parallax.length) return;
    var vh = window.innerHeight;
    parallax.forEach(function (img) {
      var box = img.parentElement.getBoundingClientRect();
      if (box.bottom < 0 || box.top > vh) return;
      var p = (box.top + box.height / 2 - vh / 2) / vh;
      img.style.transform = "translate3d(0," + (p * -7).toFixed(2) + "%,0) scale(1.15)";
    });
  }
  window.addEventListener("scroll", function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(onFrame);
  }, { passive: true });
  onFrame();

  if (reduce) return;

  /* ---------- Reveal allo scroll ---------- */
  var REVEAL = [
    ".section__title",
    ".section__subtitle",
    ".feature-card",
    ".product-card",
    ".tp-card",
    ".tp__heading",
    ".faq details",
    ".trust-item",
    ".social-video-card",
    ".social-videos__heading",
    ".image-banner__content",
    ".hero__grid > *",
    ".featured-products__viewall",
    ".product-info .accordion",
    ".lifestyle",
    ".site-footer__grid > *",
    ".cozy-wordmark"
  ].join(",");

  if ("IntersectionObserver" in window) {
    var vh = window.innerHeight;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-in");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -6% 0px", threshold: 0.06 }
    );
    var siblings = new Map();
    Array.prototype.forEach.call(document.querySelectorAll(REVEAL), function (el) {
      if (el.closest(".cart-drawer, .menu-drawer, .product-gallery")) return;
      var parent = el.parentElement;
      var i = siblings.get(parent) || 0;
      siblings.set(parent, i + 1);
      el.style.setProperty("--rv-d", Math.min(i, 6) * 85 + "ms");
      el.classList.add("cozy-rv");
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) el.classList.add("is-in");
      else io.observe(el);
    });
    root.classList.add("cozy-ready");
  }

  if (!fine) return;

  /* ---------- Alone caldo che segue il cursore ---------- */
  var cursor = document.querySelector(".cozy-cursor");
  var tx = 0, ty = 0, cx = 0, cy = 0, looping = false;
  var SPOT = ".hero-banner";

  function loop() {
    cx += (tx - cx) * 0.12;
    cy += (ty - cy) * 0.12;
    cursor.style.transform = "translate3d(" + cx.toFixed(1) + "px," + cy.toFixed(1) + "px,0)";
    if (Math.abs(tx - cx) > 0.4 || Math.abs(ty - cy) > 0.4) requestAnimationFrame(loop);
    else looping = false;
  }

  document.addEventListener("pointermove", function (e) {
    if (e.pointerType && e.pointerType !== "mouse") return;
    tx = e.clientX;
    ty = e.clientY;
    if (cursor) {
      if (!cursor.classList.contains("is-on")) {
        cx = tx; cy = ty;
        cursor.classList.add("is-on");
      }
      if (!looping) {
        looping = true;
        requestAnimationFrame(loop);
      }
    }
    var spot = e.target && e.target.closest ? e.target.closest(SPOT) : null;
    if (spot) {
      var r = spot.getBoundingClientRect();
      spot.style.setProperty("--mx", (e.clientX - r.left).toFixed(0) + "px");
      spot.style.setProperty("--my", (e.clientY - r.top).toFixed(0) + "px");
    }
  }, { passive: true });
  document.addEventListener("mouseout", function (e) {
    if (!e.relatedTarget && cursor) cursor.classList.remove("is-on");
  });

  /* ---------- Zoom lente galleria prodotto ---------- */
  var gallery = document.querySelector(".product-gallery__main");
  if (gallery) {
    gallery.addEventListener("pointerenter", function () { gallery.classList.add("is-zoom"); });
    gallery.addEventListener("pointermove", function (e) {
      var img = gallery.querySelector("img");
      if (!img) return;
      var r = gallery.getBoundingClientRect();
      img.style.transformOrigin =
        (((e.clientX - r.left) / r.width) * 100).toFixed(1) + "% " +
        (((e.clientY - r.top) / r.height) * 100).toFixed(1) + "%";
    });
    gallery.addEventListener("pointerleave", function () { gallery.classList.remove("is-zoom"); });
  }
})();
